module.exports = __webpack_public_path__ + "img/advocate3.5049ff39.jpg";